import InitialData from "./appData/initialData"
import { isBanner, isPromo } from "./utils/utils"

function createStyleConfig(data: InitialData) {
  if (isBanner()) {
    return createBannerStyleConfig(data)
  }

  if (window.location.pathname.includes("importPhotos")) {
    return createImportPhotosStyleConfig(data)
  }

  let backgroundColor = data.darkMode ? "#1d212b" : "#f1f4f8"
  const promo = isPromo()
  if (promo) {
    backgroundColor = "#1d212b"
  }

  return {
    statusBarStyle: "visible",
    hideInsets: true,
    hideBackButton: true,
    hideNavigationBar: true,
    backgroundColor,
    isPromo: promo,
  }
}

function createImportPhotosStyleConfig(data: InitialData) {
  const navigationBarColor = data.darkMode ? "#1d212b" : "#f8f9fa"
  const statusBarStyle = data.darkMode ? "light" : "dark"

  return {
    statusBarStyle,
    hideInsets: true,
    hideBackButton: true,
    hideNavigationBar: false,
    navigationBarTitle: "",
    navigationBarColor,
    navigationBarLineColor: navigationBarColor,
  }
}

function createBannerStyleConfig(initialData: InitialData) {
  const isAlbumList = initialData?.source == "albumListTop"
  const isBlackFriday2025 =
    window.location.pathname.includes("promoBlackFriday2025") ||
    window.location.pathname.includes("promoCyberMonday2025")

  if (isBlackFriday2025) {
    return {
      height: 90,
      margin: 16,
      isPromo: true,
    }
  }

  const isBlackFriday = window.location.pathname.includes("blackFriday")

  return {
    height: isBlackFriday ? 170 : 210,
    margin: isAlbumList ? 0 : 16,
    isPromo: true,
  }
}

export default createStyleConfig
